import React from 'react';
import PropTypes from 'prop-types';

import { createStructuredSelector } from 'reselect';
import injectReducer from 'utils/injectReducer';
import injectSaga from 'utils/injectSaga';
import { connect } from 'react-redux';
import { compose } from 'redux';
import Badge from './badge';
import reducer from '../HorizontalFilter/reducer';
import saga from '../HorizontalFilter/saga';
import {
  makeSelectSelectedTags,
  makeSelectTagsEnabled,
} from '../HorizontalFilter/selectors';
import {
  addOption,
  hideTag,
  removeOption,
  showTag,
} from '../HorizontalFilter/actions';
import { messages } from './messages';

import './styles.scss';

import _ from 'lodash';

class Choice extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };
    this.id = _.uniqueId();
  }

  handleOnClick = (value, label, active) => {
    if (!this.props.hasConfirmMessage || (this.props.hasConfirmMessage && confirm(messages.confirmMessageEdit))) {
      if (active) {
        this.props.removeOption(value);
        this.props.showTag(value);
      } else {
        this.props.addOption(value, label);
        this.props.hideTag(value);
      }
    }
  };

  handleOnShow = e => {
    this.setState(prevState => ({
      show: !prevState.show,
    }));
  };

  render() {
    const { label, tags, selectedTags, isEnabled } = this.props;
    const { show } = this.state;
    const selected = new Set();
    selectedTags.map(item => selected.add(item.value));
    let componentId = `search-filters-choice-${label}-${this.id}`.replace(/\s+/g, '-').toLowerCase();

    if (tags.length < true) return null;

    return (
      <div className="Choice mb-4">

        <h4 className="todo-sidebar-section-header">
          <label htmlFor={componentId} className='mb-0'>
          {label}
          </label>
        </h4>
        <div className="todo-sidebar-section-contents" id={componentId}>
          {tags.map((item, key) => {
            if (item === undefined) return null;
            if (!show && key >= 4) return null;
            const active = selected.has(item.value);

            return (
              <Badge
                label={item.label}
                key={key}
                active={active}
                disabled={!isEnabled}
                showIcon={false}
                onClick={() =>
                  this.handleOnClick(item.value, item.label, active)
                }
              />
            );
          })}
        </div>
      </div>
    );
  }
}

Choice.defaultProps = {};
Choice.propTypes = {
  label: PropTypes.string.isRequired,
};

const mapStateToProps = createStructuredSelector({
  selectedTags: makeSelectSelectedTags(),
  isEnabled: makeSelectTagsEnabled(),
});
export function mapDispatchToProps(dispatch) {
  return {
    addOption: (value, label) => dispatch(addOption(value, label)),
    removeOption: value => dispatch(removeOption(value)),
    hideTag: value => dispatch(hideTag(value)),
    showTag: value => dispatch(showTag(value)),
  };
}

const withReducer = injectReducer({ key: 'filters', reducer });
const withSaga = injectSaga({ key: 'filters', saga });

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withReducer,
  withSaga,
  withConnect,
)(Choice);
